import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getCateringFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How do I hire a food ${vehicleType} for an event in ${cityName}?`,
    answer: `Hiring a food ${vehicleType} in ${cityName} is easy with ${siteTitle}. Simply submit your event details—such as date, location, guest count, and food preferences—and we'll connect you with available food ${vehicleType}s that fit your needs. You'll receive custom quotes, can message vendors directly, and book the right ${vehicleType} for your event in just a few clicks.`
  },
  ...(cityName === 'Seattle' ? [
      {
        question: 'How can I book a food truck in Bellevue for a corporate event?',
        answer: "SeattleFoodTruck.com regularly books food trucks for corporate events in Bellevue and across the Eastside. Whether you're planning an office lunch, employee appreciation event, or client gathering, you can request quotes from experienced food trucks that are familiar with corporate campuses, timing requirements, and large group service. Our team is also available to help with coordination and logistics."
      },
      {
        question: 'Is food truck catering available in Redmond for weddings or private parties?',
        answer: 'Yes. Food truck catering is a popular option for weddings and private events in Redmond. SeattleFoodTruck.com works with food trucks that cater everything from wedding receptions and rehearsal dinners to birthday parties and backyard celebrations. You can choose from a wide range of cuisines and service styles to match your event and guest preferences.'
      },
      {
        question: 'Can I hire a food truck for my wedding or private event in Tacoma?',
        answer: 'Absolutely. SeattleFoodTruck.com connects clients with food trucks that cater weddings, private parties, and community events throughout Tacoma and the surrounding areas. Our vendors are experienced in off-site catering and can accommodate a variety of venues, guest counts, and service formats, making food trucks a flexible and memorable option for your event.'
      }
    ] : []),
  {
    question: `How much does it cost to hire a food ${vehicleType} for an event in ${cityName}?`,
    answer: `The cost to hire a food ${vehicleType} in ${cityName} depends on factors like the number of guests, menu selection, service time, and event location. Smaller events may start at a few hundred dollars, while larger corporate events, weddings, or festivals can range higher. ${siteTitle} allows you to compare real quotes from food ${vehicleType}s so you can find the best option for your budget with no hidden fees.`
  }
];

function CateringFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getCateringFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default CateringFaq;
